import { API } from 'constants/api-endpoints';

import { tokenInstance } from 'lib/axios/instance';

export const deleteAvatarCategoryCache = async (body) => {
  await tokenInstance.post(`${API.AVATARS}/category/cache`, body);
};
